// Import Packages

import React, { useEffect, useRef, useState } from "react";
import ReactDataSheet from "react-datasheet";
import { useSetRecoilState } from 'recoil';
import { useTranslation } from "react-i18next";

// Import Material UI
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { Button, Dialog, DialogContent, IconButton } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MoreVertIcon from '@material-ui/icons/MoreVert';

// Import Pages
import { TabPanel } from '../../components/FlowConfigurationInputs/index'
import { alertState } from '../../recoil-store/recoil-state';
import close from "../../assets/icons/close.svg";

// Import Helpers
import { getExtension } from '../../helpers/helper';

// Import CSS
import "react-datasheet/lib/react-datasheet.css";
import "./DataTableVariableEditor.css";


export default function DataTableVariableEditor({
  data,
  setData,
  from
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DATA-TABLE.ASSIGN.";
  const [selected, setSelected] = useState(null);
  const [tab, setTab] = useState('manuel');
  const [tempData, setTempData] = useState([]);
  const [smallData, setSmallData] = useState();
  const [isBiggerData, setIsBiggerData] = useState({});
  const [isFullScreenBiggerData, setIsFullScreenBiggerData] = useState({});
  const [addMoreColumnCount, setAddMoreColumnCount] = useState(100);
  const [addMoreRowCount, setAddMoreRowCount] = useState(100);
  const [open, setOpen] = useState(false);
  const setAlert = useSetRecoilState(alertState);

  useEffect(() => {
    if (data && data?.length) {
      let copyData = []
      let isBigger = { column: false, row: false }
      data.forEach((item, index) => {
        if (index < 10) {
          const copyItem = item.filter((data, index) => {
            if (index < 9) {
              return true
            }
            else if (!isBigger.column) {
              isBigger = { ...isBigger, column: true }
            }
            return false
          })
          copyData.push(copyItem)
        }
        else if (!isBigger.row) {
          isBigger = { ...isBigger, row: true }
        }
        return
      })
      setSmallData(copyData)
      setIsBiggerData(isBigger)
    }
  }, [data])

  useEffect(() => {
    if (isBiggerData.row) {
      const smallTable = document.querySelector(".small-table-container .data-grid").offsetWidth
      const rowExpandIcon = document.querySelector(".expand-row-show-icon")
      rowExpandIcon.style.width = smallTable + "px"
    }
  }, [isBiggerData])

  // Handle cell value changes
  const onCellsChanged = (changes) => {
    const grid = data.map((row) => [...row]);
    changes.forEach(({ cell, row, col, value }) => {
      grid[row][col] = value;
    });
    // Update state
    setData(grid);
  };

  // Handle temp cell value changes
  const onTempCellsChanged = (changes) => {
    const grid = tempData.map((row) => [...row]);
    changes.forEach(({ cell, row, col, value }) => {
      grid[row][col] = value;
    });
    // Update state
    setTempData(grid);
  };

  const handleDialogClick = () => {
    let copyData = []
    let isBigger = { column: false, row: false }
    data.forEach((item, index) => {
      if (index < 100) {
        const copyItem = item.filter((data, index) => {
          if (index < 100) {
            return true
          }
          else if (!isBigger.column) {
            isBigger = { ...isBigger, column: true }
          }
          return false
        })
        copyData.push(copyItem)
      }
      else if (!isBigger.row) {
        isBigger = { ...isBigger, row: true }
      }
      return
    })
    setTempData(copyData);
    setIsFullScreenBiggerData(isBigger)
    setAddMoreColumnCount(100)
    setAddMoreRowCount(100)
    // setTempData(JSON.parse(JSON.stringify(data)));
    setOpen(true);
  };
  const handleClose = () => {
    setSelected(null);
    setOpen(false);
  };

  // Handle adding new row
  const handleAddRow = (e) => {
    if (from === "editVariable") {
      let copyData = []
      let isBigger = { column: false, row: false }
      data.forEach((item, index) => {
        if (index < addMoreRowCount + 10) {
          const copyItem = item.filter((data, index) => {
            if (index < addMoreColumnCount) {
              return true
            }
            else {
              isBigger = { ...isBigger, column: true }
            }
            return false
          })
          copyData.push(copyItem)
        }
        else {
          isBigger = { ...isBigger, row: true }
        }
        return
      })
      setTempData(copyData);
      setIsFullScreenBiggerData(isBigger)
      setAddMoreRowCount((pre) => pre + 10)
      return
    }
    let newRow = [];
    if (tempData[0]?.length) {
      // Push column values
      for (let i of tempData[0]) {
        newRow.push("");
      }
    } else {
      newRow.push("");
    }
    tempData.push(newRow);
    // Add new row
    setTempData([...tempData]);
    setSelected(null);
  };
  // Handle adding new column
  const handleAddColumn = (e) => {
    if (from === "editVariable") {
      let copyData = []
      let isBigger = { column: false, row: false }
      data.forEach((item, index) => {
        if (index < addMoreRowCount) {
          const copyItem = item.filter((data, index) => {
            if (index < addMoreColumnCount + 10) {
              return true
            }
            else {
              isBigger = { ...isBigger, column: true }
            }
            return false
          })
          copyData.push(copyItem)
        }
        else {
          isBigger = { ...isBigger, row: true }
        }
        return
      })
      setTempData(copyData);
      setIsFullScreenBiggerData(isBigger)
      setAddMoreColumnCount((pre) => pre + 10)
      return
    }
    for (let item of tempData) {
      // Push row values
      item.push("");
    }
    setTempData([...tempData]);
    setSelected(null);
  };

  // Handle removing row
  const handleRemoveRow = (e) => {
    // Remove row
    if (selected) {
      if (selected.end.i < selected.start.i) {
        if (selected.end.i === 0) {
          if (selected.end.i === selected.start.i) {
            return;
          }
          selected.end.i += 1;
        }
        tempData.splice(selected.end.i, selected.start.i - selected.end.i + 1);
      } else {
        if (selected.start.i === 0) {
          if (selected.end.i === selected.start.i) {
            return;
          }
          selected.start.i += 1;
        }
        tempData.splice(selected.start.i, selected.end.i - selected.start.i + 1);
      }
    }
    if (tempData.length === 0) {
      setTempData([[""]]);
    } else {
      setTempData([...tempData]);
    }
    setSelected(null);
  };

  // Handle removing column
  const handleRemoveColumn = (e) => {
    if (selected) {
      for (let item of tempData) {
        if (selected.end.j < selected.start.j) {
          item.splice(selected.end.j, selected.start.j - selected.end.j + 1);
        } else {
          item.splice(
            selected.start.j,
            selected.end.j - selected.start.j + 1
          );
        }
      }
    }
    if (tempData[0].length === 0) {
      setTempData([[""]]);
    } else {
      setTempData([...tempData]);
    }
    setSelected(null);
  };

  const handleSelect = (index) => {
    setSelected(index);
  };

  const getSelected = type => {
    if (selected.end[type] < selected.start[type]) {
      return selected.start[type] - selected.end[type] + 1;
    } else {
      return selected.end[type] - selected.start[type] + 1;
    }
  }

  const handleFileChange = (event) => {
    if (event.target.files[0]?.name) {
      let extension = getExtension(event.target.files[0]?.name);
      if (extension === 'xlsx') {
        setData(d => ({ ...d, file: event.target.files[0] }));
      } else {
        setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.LICENSE.LICENSE-XML-FORMAT'), severity: 'error' }))
      }
    }
  };

  const changeSheetName = (event) => {
    setData(d => ({ ...d, sheetName: event.target.value }));
  };

  function addLicense() {
    document.getElementById("excel-file-input").click();
  }

  const changeTab = (v) => {
    if (v === 'manuel') {
      setData([
        ['', ''], ['', '']
      ]);
    } else {
      setData(undefined);
    }
    setTab(v)
  }

  const handleCancel = () => {
    setOpen(false);
  }

  const handleSave = () => {
    setData(JSON.parse(JSON.stringify(tempData)));
    setOpen(false);
  }

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <div style={{ display: 'flex' }}>
          <div className="condition-tabs form-element">
            <button className={`col-4 ${tab === 'manuel' ? 'condition-active' : ''}`}
              value="manuel" onClick={() => changeTab('manuel')}>
              Manuel
            </button>
            <button className={`col-4 ${tab === 'browse' ? 'condition-active' : ''}`}
              value="browse" onClick={() => changeTab('browse')}>
              Browse
            </button>
          </div>
        </div>
        <TabPanel value={tab} index={'manuel'}>
          <div className="small-table-container" style={{ display: "flex" }}>
            <ReactDataSheet
              data={smallData ? smallData : data}
              valueRenderer={(cell) => cell}
              onCellsChanged={onCellsChanged}
            />
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button onClick={handleDialogClick} style={{ height: 30, marginTop: "-8px", padding: 0, minWidth: "44px" }}>
                <FullscreenIcon />
              </Button>
              {isBiggerData?.column && <MoreHorizIcon style={{ margin: "auto" }} />}
            </div>
          </div>
          {isBiggerData?.row && <div>
            <MoreVertIcon className="expand-row-show-icon" style={{ marginTop: "10px" }} />
          </div>}
          {open && <Dialog
            id="large-table-dialog"
            data-test="show-large-table"
            open={true} maxWidth="lg" >
            <DialogContent className="button-group-content">
              <div >
                <Button
                  variant="outlined"
                  onClick={handleAddRow}
                  style={{ marginRight: 5, color: `${from === "addVariable" || isFullScreenBiggerData.row ? "#43AA41" : "#b3ddb3"}` }}
                  disabled={from === "editVariable" && !isFullScreenBiggerData.row}
                >
                  {t(label + (from === "editVariable" ? "EXPAND-ROW" : "ADD-ROW"))}
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleAddColumn}
                  style={{ marginRight: 5, color: `${from === "addVariable" || isFullScreenBiggerData.column ? "#43AA41" : "#b3ddb3"}` }}
                  disabled={from === "editVariable" && !isFullScreenBiggerData.column}
                >
                  {t(label + (from === "editVariable" ? "EXPAND-COLUMN" : "ADD-COLUMN"))}
                </Button>
                {from === "addVariable" &&
                  <>
                    <Button
                      variant="outlined"
                      onClick={handleRemoveRow}
                      disabled={!selected}
                      style={{ marginRight: 5, color: !selected ? "#F5C6C6" : "#D75E5E" }}
                    >
                      {t(label + "REMOVE-ROW", { count: selected ? getSelected('i') : '' })}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleRemoveColumn}
                      disabled={!selected}
                      style={{ color: !selected ? "#F5C6C6" : "#D75E5E" }}
                    >
                      {t(label + "REMOVE-COLUMN", { count: selected ? getSelected('j') : '' })}
                    </Button>
                  </>
                }
              </div>

              <div className="save-cancel-content">
                <Button
                  className="cancel-data-table-button"
                  variant="outlined"
                  onClick={handleCancel}
                >
                  {t("CONTENT.FLOW.CANCEL")}
                </Button>

                {from === "addVariable" &&
                  <Button
                    className="save-data-table-button"
                    variant="outlined"
                    onClick={handleSave}
                  >
                    {t("CONTENT.FLOW.SAVE")}
                  </Button>
                }
              </div>

            </DialogContent>
            <DialogContent className="large-table-container" >
              <div style={{ display: "flex" }}>
                <ReactDataSheet
                  data={tempData}
                  valueRenderer={(cell) => cell}
                  onSelect={handleSelect}
                  onCellsChanged={onTempCellsChanged}
                />
                <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
                  {isFullScreenBiggerData?.column && <MoreHorizIcon />}
                </div>
              </div>
              {isFullScreenBiggerData?.row && <div style={{ marginTop: "10px", justifyContent: "center", display: "flex" }}>
                <MoreVertIcon className="fullscreen-expand-row-show-icon" />
              </div>}
            </DialogContent>
          </Dialog>}
        </TabPanel>
        <TabPanel value={tab} index={'browse'}>

          <div className="mail-server-bottom-section">
            <input type="file" name="file" accept=".xlsx" hidden id="excel-file-input"
              onChange={handleFileChange} />
            <div className="mail-server-button-save" onClick={addLicense}>
              {t(label + "UPLOAD-PREVIEW-FILE")}
            </div>
            {
              data && data.file && data.file.name &&
              <TextField
                placeholder="Sheet Name"
                size="small"
                style={{ width: '22%', marginLeft: '12px' }}
                id="outlined-basic"
                variant="outlined"
                value={data && data.sheetName ? data.sheetName : ''}
                onChange={changeSheetName}
                inputProps={{ style: { fontSize: 12 } }}
              />
            }

          </div>
          <small className="mail-server-small-text">{data && data.file && data.file.name}</small>

        </TabPanel>

      </div>
    </div >
  );
}
